import { render, staticRenderFns } from "./AssetTableLight.vue?vue&type=template&id=372ee68a"
import script from "./AssetTableLight.vue?vue&type=script&lang=js"
export * from "./AssetTableLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports